
import { http } from "../http-common";

const fetchCountries = () => {
  return http.get('/countries');
};
const fetchProfiles = () => {
  return http.get('/profile/list?pageNumber=0&size=1000');
};
const fetchPickList = (data) => {
  return http.post('/picklist',data);
};
const saveUserTrack = (data) => {
  return http.post('/user-action-tracker',data);
};

const CommonService = {
  fetchCountries,
  fetchProfiles,
  fetchPickList,
  saveUserTrack
};

export default CommonService;

